<template>
  <section class="contact--basic">
    <v-container>
      <v-layout column>
        <v-flex sm12>
          <div class="contact--header-grid">
            <div class="contact--header-col-9">
              <div class="d-flex">
                <v-text-field
                  label="Search Entities By Name"
                  v-model="opts.name"
                  @keyup.enter="query"
                  style="width: 90%;"
                />
                <div>
                  <v-btn icon color="primary" @click="query">
                    <v-icon>search</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <div>
              <v-btn outline color="primary" to="/evoting/entity/create">
                <v-icon left>add</v-icon>Create New
              </v-btn>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider/>
    <section>
      <v-container grid-list-md>
        <v-layout column>
          <v-flex sm12>
            <div class="contact--list-grid">
              <div class="contact--span-col-4">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="contact--text-style">NAME</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <div class="contact--span-col-2">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="contact--text-style">COMPANY</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <div class="contact--span-col-2">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="contact--text-style">SCRUTINIZER</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <div>
                <v-list-tile-action>
                  <v-btn icon color="primary" disabled>
                    <v-icon>menu</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <v-divider/>
    <section v-if="loaded">
      <v-container grid-list-md>
        <v-layout column>
          <v-flex sm12 v-for="entity in entities.docs" :key="entity.id">
            <v-card>
              <div class="contact--list-grid">
                <div class="contact--span-col-4">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title style="text-transform: capitalize;">
                        <router-link :to="`/evoting/entity/${entity.id}`">{{entity.name}}</router-link>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
                <div class="contact--span-col-2">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <router-link
                          :to="`/company/${entity.company.id}`"
                        >{{entity.company.name || entity.company.id || "NOT FOUND"}}</router-link>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
                <div class="contact--span-col-2">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <router-link
                          :to="`/user-accounts/${entity.scrutinizer.id}`"
                        >{{entity.scrutinizer.name || entity.scrutinizer.id || "NOT FOUND"}}</router-link>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
                <div>
                  <v-list-tile-action>
                    <v-menu bottom left nudge-top="-40">
                      <v-btn slot="activator" icon>
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                      <v-list>
                        <!-- VIEW THE ENTITY -->
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-btn flat :to="`/evoting/entity/${entity.id}`">
                              <v-icon>remove_red_eye</v-icon>&nbsp;
                              View
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                        <!-- UPDATE THE ENTITY -->
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-btn flat :to="`/evoting/entity/${entity.id}?update=1`">
                              <v-icon>edit</v-icon>&nbsp;
                              Update
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                        <!-- DELETE THE ENTITY -->
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-btn flat :to="`/evoting/entity/${entity.id}?delete=1`">
                              <v-icon>delete</v-icon>&nbsp;
                              Delete
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-list-tile-action>
                </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex sm12 v-if="(entities.docs || []).length < 1">
            <div class="text-xs-center" style="margin: 50px auto;">
              <h2 style="font-size: 40px;">No Entities Found!</h2>
            </div>
          </v-flex>
        </v-layout>

        <div class="text-xs-center">
          <v-pagination :length="entities.pages" :total-visible="8" v-model="opts.page"/>
        </div>
      </v-container>
    </section>
    <section v-else>
      <Loader/>
    </section>
  </section>
</template>
<script>
import { coreClient } from "../../apollo";
import gql from "graphql-tag";
import Loader from "../../components/loader";
import generateSnackbarError from "../generateSnackbarError";
export default {
  components: {
    Loader
  },
  data() {
    return {
      loaded: false,
      entities: {
        docs: [],
        pages: 0,
        page: 0,
        total: 0
      },
      opts: {
        name: "",
        page: 1
      }
    };
  },
  methods: {
    getEntities(variables = {}) {
      const obs = coreClient.watchQuery({
        query: gql`
          query entities($name: String, $page: Int) {
            Entities(name: $name, page: $page) {
              total
              pages
              page
              docs {
                id
                name
                company {
                  ... on Company {
                    id
                    name
                  }
                  ... on CompanyId {
                    id
                  }
                }
                scrutinizer {
                  ... on User {
                    id
                    name
                    email
                  }
                  ... on UserId {
                    id
                  }
                }
              }
            }
          }
        `,
        variables,
        fetchPolicy: "cache-and-network"
      });
      obs.subscribe(
        ({ loading, data }) => {
          this.loaded = !loading;
          if (data) {
            this.entities = data.Entities;
          }
        },
        err => {
          this.loaded = true;
          this.$store.commit(
            "updateSnackbar",
            generateSnackbarError(err, "Entities")
          );
        }
      );
    },
    query() {
      this.getEntities(this.opts);
    }
  },
  async mounted() {
    let { query } = this.$route;
    this.opts.page = Number(query.page) || this.opts.page;

    await this.query();

    this.$watch("opts.page", async page => {
      this.$router.push({
        name: "EvotingEntity",
        query: { ...query, page: this.opts.page }
      });

      await this.query();
    });

    this.$watch("opts.name", async val => {
      if (val === "") {
        await this.query();
      }
    });
  }
};
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/Entities.styl';
</style>
